<template>
    <nav class="wizard-steps-list">
        <ul class="wizard-steps-list__inner">
            <li :class="{
                    'wizard-steps-list__item': true,
                    'is-active': (index === activeStep - 1),
                    'is-completed': (index < activeStep - 1),
                    'pointer': (index <= 1 || groupKinds.length)
                }"
                v-for="(step, index) in steps" :key="index">
                <span class="wizard-steps-list__label" @click="emitStepChanges(index)" v-html="step"></span>
            </li>
        </ul>
    </nav>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        activeStep: {
            type: Number,
            required: true
        },
        steps: {
            type: Array,
            required: true
        }
    },
    methods: {
      emitStepChanges(index) {
        if (index === 0) {
          this.$emit('changeStep', index + 1);
          return;
        }

        if (this.groupKinds.length === 0 && index === 1) {
          this.$emit('changeStep', index + 1);
          return;
        }

        return this.groupKinds.length > 0 ? this.$emit('changeStep', index + 1) : null
      },
    },
    computed: {
        ...mapState('editor', ['groupKinds']),
    },
}
</script>
